<div class="referral-wrapper current-referrals">
	<div class="confirmed-appointment with-request-appointment">
		<div class="row">
			<div class="col-md-12">
				<!-- Not present in current wireframe -->
				<!-- <div class="r-p-title-container">
          <div class="title">
            <h2 [translate]="'referral.confirmed-appts.title'">Confirmed Appointments</h2>
          </div>
          <div class="addons" *ngIf="!noData">
            <a (click)="print()">
              <i class="fa fa-print"></i>
              <span [translate]="'referral.print.title'">Print</span>
            </a>
          </div>
        </div> -->
				<ng-container *ngIf="data && !noData">
					<p [translate]="'referral.confirmed-appts.description'">The following appointments have been scheduled.</p>
					<p>
						<span [translate]="'referral.confirmed-appts.have-questions'"
							>Have any questions? Contact the EHE Referral Team via our</span
						>
						<span class="link" (click)="sendMessage()" appEheAnalytics [data]="analyticsData">
							<span class="px-1" [translate]="'referral.confirmed-appts.have-questions-link'">
								secure messaging system
							</span>
						</span>
						<span [translate]="'referral.confirmed-appts.have-questions-number'"
							>or call 212.332.3657 Monday - Friday 8 am - 5 pm EST.</span
						>
					</p>
				</ng-container>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<ng-container *ngFor="let category of data.category">
					<ng-container *ngFor="let referral of category.referral">
						<div class="c-r-module">
							<mat-accordion>
								<mat-expansion-panel>
									<mat-expansion-panel-header>
										<div class="title">
											<h3>{{ referral.specialtyName }}</h3>
											<p>Last updated: {{ referral.lastUpdatedDate }}</p>
										</div>
									</mat-expansion-panel-header>
									<mat-panel-description>
										<div class="c-r-content">
											<ng-container *ngFor="let provider of referral.provider">
												<div class="c-r-row c-r-clear-border">
													<div class="c-r-r-label">
														<div class="address-checkbox">
															<div>
																<b [translate]="'referral.confirmed-appts.appointment-time.title'">Appointment Time:</b>
															</div>
															<div>{{ provider?.appt?.apptDateTime }}</div>
															<div
																class="link ml-0"
																(click)="generateCalendarEvent(provider)"
																[translate]="'referral.confirmed-appts.add-to-calendar.title'"
																appEheAnalytics
																[data]="{
																	pageUrl: '/wellness/referral/current/confirmed/appointments',
																	redirectedTo: '/wellness/referral/current/confirmed/appointments',
																	componentName: 'confirmed-appointments',
																	id: 'Confirmed patient appointment Add to Calendar'
																}">
																Add to Calendar
															</div>
														</div>
														<div class="address-checkbox">
															<div>
																<b>{{ provider.name }}</b>
															</div>
															<span>{{ provider.practiceName }}</span>
															<span>{{ provider.address }}, {{ provider.address2 }}</span>
															<span>{{ provider.city }}, {{ provider.state }} {{ provider.zip }}</span>
															<div *ngIf="provider.phone && provider.phone !== 'null'">
																<span>{{ provider.phoneExtension }}</span>
																<span>{{ provider.phoneExtension ? ' - ' : '' }}</span>
																<span>{{ provider.phone }}</span>
															</div>
															<div class="d-block link with-request-appointment">
																<span [translate]="'referral.directions.title'" class="non-clickable">
																	Directions & Map</span
																>
															</div>
														</div>
													</div>
													<div class="c-r-r-val">
														<div class="m-l-30 p-l-5" [innerHtml]="provider.appt?.note"></div>
													</div>
												</div>
											</ng-container>
										</div>
									</mat-panel-description>
								</mat-expansion-panel>
							</mat-accordion>
						</div>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="noData">
					<div class="align-center">{{ noDataMsg }}</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
